// extracted by mini-css-extract-plugin
module.exports = {"centeredContainer":"Shops_centeredContainer__2KHB4","container":"Shops_container__1Smkv","title":"Shops_title__2x06H","link":"Shops_link__2JH20"};